import { render } from "./spinner.vue?vue&type=template&id=0c00e6f8&scoped=true"
import script from "./spinner.vue?vue&type=script&lang=js"
export * from "./spinner.vue?vue&type=script&lang=js"

import "./spinner.vue?vue&type=style&index=0&id=0c00e6f8&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src384613071/src/admin-ui-svc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c00e6f8"]])

export default __exports__